import React from 'react'

import Image from '@/components/image/image'
import Player from '@/components/video/player/player'

import * as style from './video-banner.module.scss'

type VideoBannerProps = Queries.DatoCmsVideoBanner

const VideoBanner: React.FC<VideoBannerProps> = ({ text, background }) => {
  return (
    <section
      className={`${style.section}`}
      style={{
        ...(background?.video?.thumbnailUrl && {
          backgroundImage: `url(${background.video?.thumbnailUrl})`
        })
      }}
    >
      {background && Boolean(background?.isImage) && (
        <Image image={background.gatsbyImageData} className={style.image} />
      )}
      {background && background?.isImage === false && (
        <div className={style.containerVideo}>
          <Player
            preview={false}
            video={background.url}
            autoPlay
            muted
            loop
            controls={false}
            classes={{
              wrapper: style.videoWrapper
            }}
          />
        </div>
      )}
      <div className={`${style.content} container d-flex `}>
        <div className="row justify-content-center align-items-center">
          <div className="col-12 col-md-10">
            <h2 className={`text-base-1000 h200 text-center`}>{text}</h2>
          </div>
        </div>
      </div>
    </section>
  )
}

export default VideoBanner
